module.exports = __webpack_public_path__ + "static/img/hemd1.232a31d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/hemd1.png
// module id = zPv7
// module chunks = 0